import { SearchService } from './../../shared/services/search.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Admin } from './../../models/program/admin';

// RxJS Interfaces
import { Subject }          from 'rxjs/Subject';

@Component({
  selector: 'app-admin-input',
  templateUrl: './admin-input.component.html',
  styleUrls: ['./admin-input.component.less']
})

export class AdminInputComponent implements OnInit {
  @Input() inputId: string;
  @Input() admins: Admin[];
  @Input() differs: boolean;
  @Output() removeAdmin: EventEmitter<number> = new EventEmitter<number>();
  @Output() adminSelected: EventEmitter<Admin> = new EventEmitter<Admin>();
  public queryList: Admin[];
  private fullList: Admin[];
  public current: string;
  private stringRegEx: RegExp = /^[a-zA-Z\s]*$/;
  private searchUpdated: Subject<string> = new Subject<string>();

  constructor(private search: SearchService) {
    this.searchUpdated.subscribe(name => {
      if (name.length > 0 && this.stringRegEx.test(name)) {
        let re = new RegExp(name, 'i');
        this.queryList = this.fullList.filter(admin =>
          admin.email.search(re) > -1 || admin.name.search(re) > -1
        );
      }
      if (name.length < 1) { this.queryList = []; }
    });

    this.search.queryAdmins('').subscribe((res: Admin[]) => this.fullList = res);
  }

  ngOnInit(): void {
    if (!this.admins) { this.admins = []; }
  }

  public focus(): void {
    document.getElementById(this.inputId).focus();
  }

  public onSearchType(event: KeyboardEvent, value: string): void {
    if (event.keyCode !== 188) {
      this.searchUpdated.next(value);
    }
    if (event.keyCode === 188 && this.queryList) {
      this.adminSelected.emit(this.queryList[0]);
      this.current = '';
      this.queryList = [];
    }
    if (event.keyCode === 8 && this.current.length === 0) {
      if (this.admins.length > 0) {
        this.current = this.admins[this.admins.length - 1].name;
        this.searchUpdated.next(this.current);
      } else {
        this.current = '';
      }
      this.remove(this.admins.length - 1);
    }
  }

  public remove(index: number): void {
    this.removeAdmin.emit(index);
  }

  public addToForm(admin: Admin): void {
    this.adminSelected.emit(admin);
  }

  public blur(admin?: Admin): void {
    this.current = '';
    this.queryList = [];
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/admin-input/admin-input.component.ts